export enum LicensePackage {
  Essentials = 'Essentials'
}
